import React from 'react';
import { LeftNavLinks } from './LeftNavLinks';

const Main = ({ activeTab }) => {
  const selectedItem = LeftNavLinks["securities"]?.find(item => item.key === activeTab);
  const SelectedComponent = selectedItem?.component;

  return (
    <div className="mainContent">
      {SelectedComponent ? (
        <SelectedComponent />
      ) : (
        <div>Please select a tab</div>
      )}
    </div>
  );
};

export default Main;